import { StateParams, StateProvider } from "@uirouter/angularjs";
import {
  ProgressiveDefinitionViewController,
  HtmlTemplate as ProgressiveDefinitionViewHtmlTemplate,
} from "./views/definitions";
import {
  ProgressiveControllerTypeViewController,
  HtmlTemplate as ProgressiveControllerTypeViewHtmlTemplate,
} from "./views/controllers";

import {
  ProgressiveMeterReadingSettingsViewController,
  HtmlTemplate as ProgressiveMeterReadingSettingsViewHtmlTemplate,
} from "./views/meterReadingSettings";
import {
  ProgressiveMeterReadingValidationSettingViewController,
  HtmlTemplate as ProgressiveMeterReadingValidationSettingViewHtmlTemplate,
} from "./views/validationSettings";

import {
  DailyReadingsViewController,
  HtmlTemplate as DailyReadingsViewHtmlTemplate,
} from "./views/dailyReadings";

import {
  DailyReadingsReadingsViewController,
  HtmlTemplate as DailyReadingsReadingsViewHtmlTemplate,
} from "./views/dailyReadings/readings";
import {
  DailyReadingsMachinesViewController,
  HtmlTemplate as DailyReadingsMachinesViewHtmlTemplate,
} from "./views/dailyReadings/machines";
import {
  DailyReadingsGraphController,
  HtmlTemplate as DailyReadingsGraphHtmlTemplate,
} from "./views/dailyReadings/graph";
import {
  ProgressiveDefinitionDetailViewController,
  HtmlTemplate as ProgressiveDefinitionDetailViewHtmlTemplate,
} from "./views/definitions/detail";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../records/server/serverUtility";
import {
  ProgressiveDefinitionEditViewController,
  HtmlTemplate as ProgressiveDefinitionEditViewHtmlTemplate,
} from "./views/definitions/edit";
import {
  ProgressiveDefinitionDetailReadingsViewController,
  HtmlTemplate as ProgressiveDefinitionDetailReadingsHtmlTemplate,
} from "./views/definitions/detail/readings";
import { vsComponentName as progressiveDefinitionsDetailMachineEditViewComponentName } from "./views/definitions/detail/machines/edit";
import { Record } from "../records/server/crud";
import {
  ProgressiveControllerTypeEditViewController,
  HtmlTemplate as ProgressiveControllerTypeEditViewHtmlTemplate,
} from "./views/controllers/add";
import {
  ProgressiveMeterReadingSettingsEditViewController,
  HtmlTemplate as ProgressiveMeterReadingSettingsEditViewHtmlTemplate,
} from "./views/meterReadingSettings/add";
import {
  RecordsUtilsService,
  vsName as RecordsUtilsServiceName,
} from "../records/utils";
import { cloneDeep } from "lodash";
import {
  ReportingServer,
  vsName as ReportingServerName,
} from "../reporting/server";
import {
  ProgressiveModuleConfigurationService,
  vsServiceName as ProgressiveModuleConfigurationServiceName,
} from "./progressiveModuleConfigurationService";
import { ProgressivesContext } from "./views/model/progressivesContext";
import { Property } from "../property/model/Property";
import { IQueryResponse } from "../records/server/query";
// import {
//   ProgressiveEscrowReadingsViewController,
//   HtmlTemplate as ProgressiveEscrowReadingsViewHtmlTemplate,
//   ProgressiveEscrowReadingsReadingsViewController,
//   ReadingsHtmlTemplate as ProgressiveEscrowReadingsReadingsViewHtmlTemplate,
//   ProgressiveEscrowReadingsRequestsViewController,
//   RequestsHtmlTemplate as ProgressiveEscrowReadingsRequestsViewHtmlTemplate,
//   ProgressiveEscrowReadingsBalanceTransferViewController,
//   BalanceHtmlTemplate as ProgressiveEscrowReadingsBalanceTransferViewHtmlTemplate,
// } from "./views/escrowReadings";

// import {
//   DefinitionsDetailEscrowReadingsViewController,
//   HtmlTemplate as DefinitionsDetailEscrowReadingsViewHtmlTemplate,
// } from "./views/definitions/detail/escrowReadings";
// import {
//   ProgressiveEscrowReadingSettingsViewController,
//   HtmlTemplate as ProgressiveEscrowReadingSettingsViewHtmlTemplate,
// } from "./views/escrowReadingsSettings";
// import {
//   ProgressiveEscrowReadingSettingsEditViewController,
//   HtmlTemplate as ProgressiveEscrowReadingSettingsEditViewHtmlTemplate,
// } from "./views/escrowReadingsSettings/add";

progressiveRoutes.$inject = ["$stateProvider"];
function progressiveRoutes($stateProvider: StateProvider) {
  const basePath = "main.machines.progressives";

  const progressiveDefinitionsPath = `${basePath}.progressiveDefinitions`;
  const progressiveDefinitionsDetailPath = `${progressiveDefinitionsPath}.detail`;
  const progressiveMeterReadingSettingsPath = `${basePath}.meterReadingSettings`;
  //const progressiveEscrowReadingSettingsPath = `${basePath}.escrowReadingSettings`;
  const progressiveControllersPath = `${basePath}.controllers`;
  const progressiveDailyReadingPath = `${basePath}.progressiveDailyReading`;
  const progressiveReadingValidationSettingsPath = `${basePath}.progressiveReadingValidationSettings`;
  //const progressiveEscrowReadingsPath = `${basePath}.escrowReadings`;

  const progressiveDefinitionsApiUrl =
    "/api/machines/progressives/ProgressiveDefinition";

  $stateProvider
    .state(basePath, {
      url: "/progressives",
      template: "<ui-view></ui-view>",
      abstract: true,
      resolve: {
        date: [
          "$stateParams",
          "environment",
          function (
            $stateParams: StateParams,
            environment: { Date: Date }
          ): Date {
            return $stateParams.date || environment.Date;
          },
        ],
        progressiveReportGroup: [
          ReportingServerName,
          function (reportingServer: ReportingServer) {
            return reportingServer.getReportGroup("progressives");
          },
        ],
        properties: [ServerUtilityName, (serverUtility: ServerUtility) => serverUtility.fetchAll({
          url: "/api/properties",
          query: {}
        })],
        progressivesContext: [
          "date",
          "properties",
          function (date: Date, properties: Property[]): ProgressivesContext {
            return new ProgressivesContext(date, properties)
          },
        ],
      },
    })
    .state(progressiveDefinitionsPath, {
      url: "",
      template: ProgressiveDefinitionViewHtmlTemplate,
      controller: ProgressiveDefinitionViewController,
      controllerAs: "stateController",
    })
    .state(`${progressiveDefinitionsPath}.add`, {
      url: "/add",
      controller: ProgressiveDefinitionEditViewController,
      controllerAs: "stateController",
      template: ProgressiveDefinitionEditViewHtmlTemplate,
      resolve: {
        progressiveDefinition: [
          "$stateParams",
          RecordsUtilsServiceName,
          function (
            $stateParams: StateParams,
            recordUtils: RecordsUtilsService
          ) {
            const progressiveDefinition = cloneDeep(
              $stateParams.progressiveDefinition
            );
            recordUtils.stripIds(progressiveDefinition);
            return progressiveDefinition;
          },
        ],
      },
      params: {
        progressiveDefinition: {
          value: {},
        },
      },
    })
    .state(progressiveDefinitionsDetailPath, {
      url: "/{id:int}",
      controller: ProgressiveDefinitionDetailViewController,
      controllerAs: "stateController",
      template: ProgressiveDefinitionDetailViewHtmlTemplate,
      resolve: {
        progressiveDefinition: [
          ServerUtilityName,
          "$stateParams",
          function (serverUtility: ServerUtility, $stateParams: StateParams) {
            const id = $stateParams["id"];
            return serverUtility.getByIdWrapped({
              url: progressiveDefinitionsApiUrl,
              id,
            });
          },
        ],
      },
    })
    .state(`${progressiveDefinitionsDetailPath}.edit`, {
      url: "/edit",
      controller: ProgressiveDefinitionEditViewController,
      controllerAs: "stateController",
      template: ProgressiveDefinitionEditViewHtmlTemplate,
    })
    .state(`${progressiveDefinitionsDetailPath}.machines`, {
      url: "/machines",
      views: {
        detail: {
          componentProvider: [
            ProgressiveModuleConfigurationServiceName,
            (
              progressiveModuleConfigurationService: ProgressiveModuleConfigurationService
            ) =>
              progressiveModuleConfigurationService.detailMachineComponentName,
          ],
        },
      },
    })
    .state(`${progressiveDefinitionsDetailPath}.machines.edit`, {
      url: "/edit",
      resolve: {
        currentProgressiveDefinitionMachines: [
          "progressiveDefinition",
          ProgressiveModuleConfigurationServiceName,
          (
            progressiveDefinition: Record,
            progressiveModuleConfigurationService: ProgressiveModuleConfigurationService
          ) =>
            progressiveModuleConfigurationService.getProgressiveDefinitionMachines(
              progressiveDefinition
            ),
        ],
      },
      views: {
        "detail@^.^": {
          componentProvider: [
            ProgressiveModuleConfigurationServiceName,
            (
              progressiveModuleConfigurationService: ProgressiveModuleConfigurationService
            ) =>
              progressiveModuleConfigurationService.detailMachineEditComponentName,
          ],
        },
      },
    })
    .state(`${progressiveDefinitionsDetailPath}.readings`, {
      url: "/readings",
      views: {
        detail: {
          controller: ProgressiveDefinitionDetailReadingsViewController,
          controllerAs: "stateController",
          template: ProgressiveDefinitionDetailReadingsHtmlTemplate,
        },
      },
    })
    // .state(`${progressiveDefinitionsDetailPath}.escrowReadings`, {
    //   url: "/escrowReadings",
    //   views: {
    //     detail: {
    //       controller: DefinitionsDetailEscrowReadingsViewController,
    //       controllerAs: "stateController",
    //       template: DefinitionsDetailEscrowReadingsViewHtmlTemplate,
    //     },
    //   },
    // })
    .state(progressiveControllersPath, {
      url: "/controllers",
      template: ProgressiveControllerTypeViewHtmlTemplate,
      controller: ProgressiveControllerTypeViewController,
      controllerAs: "stateController",
    })
    .state(`${progressiveControllersPath}.add`, {
      url: "/add",
      template: ProgressiveControllerTypeEditViewHtmlTemplate,
      controller: ProgressiveControllerTypeEditViewController,
      controllerAs: "stateController",
    })
    .state(progressiveMeterReadingSettingsPath, {
      url: "/meterReadingSettings",
      template: ProgressiveMeterReadingSettingsViewHtmlTemplate,
      controller: ProgressiveMeterReadingSettingsViewController,
      controllerAs: "stateController",
    })
    .state(`${progressiveMeterReadingSettingsPath}.add`, {
      url: "/add",
      template: ProgressiveMeterReadingSettingsEditViewHtmlTemplate,
      controller: ProgressiveMeterReadingSettingsEditViewController,
      controllerAs: "stateController",
    })
    // .state(progressiveEscrowReadingSettingsPath, {
    //   url: "/escrowReadingSettings",
    //   template: ProgressiveEscrowReadingSettingsViewHtmlTemplate,
    //   controller: ProgressiveEscrowReadingSettingsViewController,
    //   controllerAs: "stateController",
    // })
    // .state(`${progressiveEscrowReadingSettingsPath}.add`, {
    //   url: "/add",
    //   template: ProgressiveEscrowReadingSettingsEditViewHtmlTemplate,
    //   controller: ProgressiveEscrowReadingSettingsEditViewController,
    //   controllerAs: "stateController",
    // })
    .state(progressiveReadingValidationSettingsPath, {
      url: "/validationSettings",
      template: ProgressiveMeterReadingValidationSettingViewHtmlTemplate,
      controller: ProgressiveMeterReadingValidationSettingViewController,
      controllerAs: "stateController",
    })
    .state(progressiveDailyReadingPath, {
      url: "/dailyReadings",
      template: DailyReadingsViewHtmlTemplate,
      controller: DailyReadingsViewController,
      controllerAs: "stateController",
    })
    .state(`${progressiveDailyReadingPath}.dailyReadings`, {
      url: "/readings",
      controller: DailyReadingsReadingsViewController,
      controllerAs: "stateController",
      template: DailyReadingsReadingsViewHtmlTemplate,
      resolve: {
        validationSettings: [
          ServerUtilityName,
          (serverUtility: ServerUtility) =>
            serverUtility
              .queryWrapped({
                url: "/api/machines/progressives/ProgressiveMeterReadingValidationSetting",
                query: {
                  Take: 1,
                },
              })
              .then((queryResponse: IQueryResponse<any>) => {
                const validationSettings = queryResponse.Results.at(0);
                return validationSettings;
              }),
        ],
      }
    })
    .state(`${progressiveDailyReadingPath}.dailyMachines`, {
      url: "/machines",
      controller: DailyReadingsMachinesViewController,
      controllerAs: "stateController",
      template: DailyReadingsMachinesViewHtmlTemplate,
    })
    .state(`${progressiveDailyReadingPath}.dailyReadingGraph`, {
      url: "/graph",
      controller: DailyReadingsGraphController,
      controllerAs: "stateController",
      template: DailyReadingsGraphHtmlTemplate,
    });
  // .state(progressiveEscrowReadingsPath, {
  //   url: "/escrowReadings",
  //   controller: ProgressiveEscrowReadingsViewController,
  //   controllerAs: "stateController",
  //   template: ProgressiveEscrowReadingsViewHtmlTemplate,
  // })
  // .state(`${progressiveEscrowReadingsPath}.readings`, {
  //   url: "/readings",
  //   controller: ProgressiveEscrowReadingsReadingsViewController,
  //   controllerAs: "stateController",
  //   template: ProgressiveEscrowReadingsReadingsViewHtmlTemplate,
  // })
  // .state(`${progressiveEscrowReadingsPath}.requests`, {
  //   url: "/requests",
  //   controller: ProgressiveEscrowReadingsRequestsViewController,
  //   controllerAs: "stateController",
  //   template: ProgressiveEscrowReadingsRequestsViewHtmlTemplate,
  // })
  // .state(`${progressiveEscrowReadingsPath}.balances`, {
  //   url: "/balances",
  //   controller: ProgressiveEscrowReadingsBalanceTransferViewController,
  //   controllerAs: "stateController",
  //   template: ProgressiveEscrowReadingsBalanceTransferViewHtmlTemplate,
  // });
}
export { progressiveRoutes as routes };
